module.exports = __webpack_public_path__ + "static/media/bartrams-garden.054c7a54.md";